import { networkRequest } from "./core";

const API_URL = process.env.REACT_APP_API_BASE_URL;

const getAllParticipants = () => {
  return networkRequest
    .get(`${API_URL}/participant/getParticipant`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

const addSingleParticipant = (first_name, last_name, phone, email, teamId) => {
  return networkRequest
    .post(`${API_URL}/participant/addParticipant`, {
      participant_first_name: first_name,
      participant_last_name: last_name,
      participant_phone_number: phone,
      participant_email: email,
      participant_team_id: teamId,
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

const addParticipant = (file, teamId) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("teamId", teamId);

  return networkRequest
    .post(`${API_URL}/participant/addBulkParticipants`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

const updateParticipant = (
  id,
  first_name,
  last_name,
  phone,
  email,
  teamId,
  created_by
) => {
  return networkRequest
    .put(`${API_URL}/participant/updateParticipant?id=${id}`, {
      participant_first_name: first_name,
      participant_last_name: last_name,
      participant_phone_number: phone,
      participant_email: email,
      participant_team_id: teamId,
      created_by,
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

const deleteParticipant = (id) => {
  return networkRequest
    .delete(`${API_URL}/participant/deleteParticipant?id=${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

const getParticipantDashboard = (id) => {
  return networkRequest
    .get(`${API_URL}/public/participant/dashboard/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

const getSampleFile = () => {
  return networkRequest
    .get(`${API_URL}/participant/sampleParticipants`, {
      responseType: "blob",
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

export const participantServices = {
  getAllParticipants,
  addSingleParticipant,
  addParticipant,
  updateParticipant,
  deleteParticipant,
  getParticipantDashboard,
  getSampleFile,
};
